// NOTE: Values manually added
export const lineHeights = {
	normal: 'normal',
	none: 1,
	shorter: 1.25,
	short: 1.3, // Altered from Chakra default
	base: 1.5,
	tall: 1.625,
	taller: '2',
	'3': '.75rem',
	'4': '1rem',
	'5': '1.25rem',
	'6': '1.5rem',
	'7': '1.75rem',
	'8': '2rem',
	'9': '2.25rem',
	'10': '2.5rem',
};
